import { Helmet } from "react-helmet-async";
import SetupProfile from "components/set-up-profile";

// Standalone route for the profile setup flow. Used when the onboarding gate
// resumes a half-onboarded user (refresh / return), mirroring the full-screen
// card layout of the onboarding audio-check page.
const SetupProfilePage = () => {
  return (
    <div className="fixed inset-0 z-50 bg-shade-50 overflow-y-auto flex items-start justify-center p-6 font-dm-sans">
      <Helmet>
        <title>Set Up Your Profile · NirvaScribe</title>
      </Helmet>

      <div className="w-full max-w-[440px] bg-white rounded-ns  p-6 md:p-7 my-auto">
        {/* Logo */}
        <div className="mb-5">
          <img src="/brand-lockup.png" alt="NirvaScribe" className="h-7 md:h-8" />
        </div>

        <SetupProfile />
      </div>
    </div>
  );
};

export default SetupProfilePage;
